<template>
  <div class="node-drag">
    <div class="node-options">
      <div align="center" class="node-select rectangle" node-type="userTask">节点</div>
      <div align="center" class="node-select rhombus start" node-type="inclusiveGateway_start">网关</div>
      <div align="center" class="node-select rhombus end" node-type="inclusiveGateway_end">汇聚网关</div>
    </div>
    <div class="nodes">
      <div class="layout-container" :style="{'background-color':dragState}">
        <node-sequence
          :nodes="nodes"
          :connections="connections"
          :margin="margin"
          :rowWidth="rowWidth"
          :rowHeight="rowHeight"></node-sequence>
        <!---->
        <grid-layout
          :layout="getNodes"
          :auto-size="false"
          :col-num="cols"
          :row-height="rowHeight"
          :max-rows="maxRows"
          :is-resizable="false"
          :vertical-compact="false"
          :margin="margin"
          :use-css-transforms="true">
          <grid-item v-for="item in getNodes" :key="item.i"
                     @move="moveEvent"
                     @moved="moved"
                     :x="item.x"
                     :y="item.y"
                     :w="1"
                     :h="1"
                     :i="item.i">
            <div align="center"
                 :class="{'userTask': item.type==='userTask',
                          'inclusiveGateway-start': item.type==='inclusiveGateway_start',
                          'inclusiveGateway-end': item.type==='inclusiveGateway_end',
                          'select': item.i === currentNodeId}"
                 @click="selectClick(item.i)"><label>{{item.name}}</label>
              <i class="el-icon-remove-outline" v-if="startNode !== item.i" @click.stop="removeNode(item.i)"></i>
            </div>
          </grid-item>
        </grid-layout>
      </div>
    </div>
  </div>
</template>
<script>
import VueGridLayout from 'vue-grid-layout'
import interact from 'interactjs'
import NodeSequence from './process-node-sequence.vue'
import _ from 'lodash'

const GridLayout = VueGridLayout.GridLayout
const GridItem = VueGridLayout.GridItem

export default {
  name: 'NodeDrag',
  props: ['nodes', 'connections', 'currentNodeId', 'startNode'],
  components: {
    GridLayout,
    GridItem,
    NodeSequence
  },
  inject: ['leftMenu'],
  data () {
    return {
      gridWidth: '',
      gridHeight: '',
      dragState: '#fff',
      margin: [20, 20],
      cols: 21,
      maxRows: 15,
      rowHeight: 40,
      // 这个不能改变拖动单元格的宽度, 是写死的
      rowWidth: 104
    }
  },
  mounted () {
    interact('.vue-grid-item')
      .draggable({
        // 这个是为了阻止拖动节点时整个画布都被拖动了, vue-grid-layout 好像没有提供阻止冒泡的东西
      })
    let _this = this
    // 设置节点的拖动
    interact('.node-select')
      .draggable({
        onstart (event) {
          _this.dragState = '#b3d9f3'
        },
        onmove (event) {
          let target = event.target
          let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
          let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy
          // translate the element
          target.style.webkitTransform =
              target.style.transform =
                'translate(' + x + 'px, ' + y + 'px)'
          // update the posiion attributes
          target.setAttribute('data-x', x)
          target.setAttribute('data-y', y)
        },
        onend (event) {
          let target = event.target
          target.style.webkitTransform =
              target.style.transform =
                'translate(0px, 0px)'
          target.setAttribute('data-x', 0)
          target.setAttribute('data-y', 0)
          _this.dragState = '#fff'
        }
      })
      // 整体布局的拖动
    interact('.layout-container')
      .draggable({
        onmove (event) {
          let target = event.target
          let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
          let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy
          let maxOffsetWidth = (target.offsetWidth - target.parentElement.offsetWidth) / 2

          let maxOffsetHeight = target.clientHeight - target.parentElement.offsetHeight
          // 限制拖动区域
          x = Math.abs(x) > maxOffsetWidth ? maxOffsetWidth * (x / Math.abs(x)) : x
          if (y > 0) {
            y = 0
          } else {
            y = Math.abs(y) > maxOffsetHeight ? parseFloat(-maxOffsetHeight) : y
          }
          // translate the element
          target.style.webkitTransform =
              target.style.transform =
                'translate(' + x + 'px, ' + y + 'px)'
          // update the posiion attributes
          target.setAttribute('data-x', x)
          target.setAttribute('data-y', y)
        }
      })
      // 拖动节点的落下
    interact('.layout-container').dropzone({
      // only accept elements matching this CSS selector
      accept: '.node-select',
      // 断点调试下, 这个地方进来了两次, 不知道怎么原因, 增加去抖函数
      ondropdeactivate: _.debounce((event) => {
        // 注意计算整个页面的偏移量(parseFloat(event.target.getAttribute('data-x'))
        let dropPointLeft = event.dragEvent.clientX - (event.target.offsetLeft + event.target.parentElement.offsetLeft + this.leftMenu.width) - (parseFloat(event.target.getAttribute('data-x')) || 0)
        let dropPointTop = event.dragEvent.clientY - (event.target.offsetTop + event.target.parentElement.offsetTop + 80) - (parseFloat(event.target.getAttribute('data-y')) || 0)
        const colWidth = (event.target.clientWidth - (_this.margin[0] * (_this.cols + 1))) / _this.cols
        let x = Math.floor((dropPointLeft - _this.margin[0]) / (colWidth + _this.margin[0]))
        let y = Math.floor((dropPointTop - _this.margin[1]) / (_this.rowHeight + _this.margin[1]))
        let nodeType = event.dragEvent.currentTarget.getAttribute('node-type')
        if (x >= 0 && x <= _this.cols && y >= 0 && y <= _this.maxRows) {
          let name = event.dragEvent.currentTarget.innerText
          _this.addNode(x, y, name, nodeType)
        }
      }, 100)
    })
  },
  methods: {
    addNode (x, y, name, nodeType) {
      this.$emit('addNode', {
        'name': name,
        'type': nodeType,
        'position': {'x': x, 'y': y}
      })
    },
    moveEvent (i, newX, newY) {
      this.dragState = '#b3d9f3'
      let node = this.nodes.find(m => m.id === i)
      if (node.position.x === newX && node.position.y === newY) {
        this.dragState = '#fff'
      } else {
        this.dragState = '#b3d9f3'
      }
    },
    moved (i, newX, newY) {
      this.$emit('updatePosition', {
        'id': i,
        'x': newX,
        'y': newY
      })
      this.dragState = '#fff'
    },
    selectClick (nodeId) {
      this.$emit('selectNodeiId', nodeId)
    },
    removeNode (nodeId) {
      this.$emit('removeNode', nodeId)
    }
  },
  computed: {
    getNodes () {
      let layout = []

      if (this.nodes) {
        this.nodes.forEach(m => {
          layout.push({
            'x': m.position.x,
            'y': m.position.y,
            'w': 1,
            'h': 1,
            'i': m.id,
            'type': m.type,
            'name': m.name
          })
        })
      }
      return layout
    }
  }
}
</script>
<style lang="scss">
  .node-drag {
    height: 100%;
    overflow: hidden;
    .node-options {
      height: 38px;
      margin: 0 auto;
      margin-top: 38px;
      width: 286px;
      position: relative;
      z-index: 2;
      > div {
        float: left;
        font-size: 12px;
      }
      .rhombus {
        margin-left: 32px;
        width: 77px;
        height: 38px;
        line-height: 38px;
        &.start {
          background: url("assets/rhombus-start.png");
        }
        &.end {
          background: url("assets/rhombus-end.png");
        }
      }
      .rectangle {
        width: 66px;
        height: 28px;
        line-height: 28px;
        margin-top: 5px;
        background: url("./assets/rectangle.png");
      }
    }
    .nodes {
      position: relative;
      height: 100%;
      overflow: hidden;
      margin-top: 60px;
      .layout-container {
        .vue-grid-item {
          > div {
            &:hover {
              .el-icon-remove-outline {
                display: block;
              }
            }
            .el-icon-remove-outline {
              cursor: pointer;
              position: absolute;
              right: -6px;
              top: -4px;
              line-height: 10px;
              color: #ff2a2a;
              display: none;
            }
            > label {
              width: 91px;
              display: block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 12px;
            }
          }
        }
        width: 2634px;
        position: absolute;
        left: 50%;
        margin-left: -1315px;
        height: 160%;
        background-color: #fff;
        background-size: calc(4.72%) 60px;
        background-image: linear-gradient(90deg, #fff 0, #fff 20px, transparent 10px, transparent 100%),
        linear-gradient(180deg, #fff 0, #fff 20px, transparent 10px, transparent 90px);
        .userTask {
          font-size: 12px;
          height: 40px;
          line-height: 40px;
          border-radius: 4px;
          background: url("./assets/rectangle-big.png") no-repeat center;
          &.select {
            background: url("./assets/rectangle-big-click.png") no-repeat center;
          }
        }
        .inclusiveGateway-start {
          font-size: 12px;
          height: 40px;
          line-height: 40px;
          background: url("assets/rhombus-start-big.png") no-repeat center;
          &.select {
            background: url("assets/rhombus-start-big-click.png") no-repeat center;
          }
        }
        .inclusiveGateway-end {
          font-size: 12px;
          height: 40px;
          line-height: 40px;
          background: url("assets/rhombus-end-big.png") no-repeat center;
          background: url("assets/rhombus-end-big-click.png") no-repeat center;
          &.select {
            background: url("assets/rhombus-end-big-click.png") no-repeat center;
          }
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/process/design/process-node-drag.vue